// Angular imports
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Inject
} from '@angular/core';

// ISPM Imports
import { ContextProviderService } from '@ispm-client/modules/context-provider/services/context-provider.service';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { NOTIFICATION_MESSAGE } from "@ispm-client/modules/aggregator/services/consts";
import { ModalLoaderNgjsService } from '@ispm/layout/services/modal-loader-ngjs.service';
import { OrderManagerBaseComponent } from '../common/order-manager-base.component';
import { OrderService } from '@ispm-client/modules/orders/services/order.service';
import { OrderSFTPService } from '../../services/order.sftp.service';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { WorkflowUtilService } from '@ispm-client/modules/aggregator/services/workflow-util.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {TestService} from '@ispm/dashboard/test/services/test.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import {ActivatedRoute} from "@angular/router";
import { RouterManagerService } from '@ispm/core/services/router-manager.service';

@Component({
  selector: 'ispm-order-manager',
  templateUrl: './order-manager.component.html',
  styleUrls: ['./order-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('orderManager')
export class OrderManagerComponent extends OrderManagerBaseComponent {

	constructor(
		private orderService: OrderService,
		private cd: ChangeDetectorRef,
		public notificationMessageService: NotificationMessageService,
		public notificationMessage: NOTIFICATION_MESSAGE,
		private formHandlerService: FormHandlerService,
		private modalLoaderService: ModalLoaderNgjsService,
        protected _authService: AuthenticationService,
		private workflowUtilService: WorkflowUtilService,
		private contextProviderService: ContextProviderService,
        protected testService : TestService,
		private orderSFTPService: OrderSFTPService,
        private _activatedRoute: ActivatedRoute,	
		private routeManagerService: RouterManagerService) {
				super( orderService, cd, notificationMessageService, notificationMessage, formHandlerService,
					 modalLoaderService, _authService, workflowUtilService, contextProviderService, testService, orderSFTPService, _activatedRoute,routeManagerService);
		}
}
